'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./list.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function List(props) {
  var numbered = props.numbered,
      list = props.list,
      children = props.children,
      unstyled = props.unstyled;
  var styledList = unstyled ? 'unbulleted' : '';
  var listItems = list ? list.map(function (listItem) {
    return _react2.default.createElement('li', {
      key: listItem,
      className: 'listItem ' + styledList + ' list-style'
    }, listItem);
  }) : null;
  var ordered = numbered ? _react2.default.createElement('ol', {
    className: 'listables'
  }, listItems, children) : _react2.default.createElement('ul', {
    className: 'listables ' + styledList
  }, listItems, children);
  return _react2.default.createElement(_react2.default.Fragment, null, ordered);
}

function LineItem(props) {
  var children = props.children;
  var content = children || null;
  return _react2.default.createElement('li', {
    className: 'list'
  }, content);
}

List.LineItem = LineItem;
exports.default = List;
List.propTypes = {
  numbered: _propTypes2.default.bool,
  list: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  children: _propTypes2.default.node,
  unstyled: _propTypes2.default.bool
};
List.defaultProps = {
  numbered: false,
  children: '',
  unstyled: false
};